export const angle = (p1: Point, p2: Point) => {
  const deltaX = p2.x - p1.x;
  const deltaY = p2.y - p1.y;

  return (Math.atan2(deltaY, deltaX) * (180 / Math.PI) + 360) % 360;
};
